<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Stock Adjustment" active>

                                <b-row v-if="hasFailedDataStockAdjustment">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedStockAdjustment.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockAdjustmentsFailed" :fields="fieldsStockAdjustment" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockAdjustment" :sort-desc.sync="sortDescStockAdjustment" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(stockAdjustmentDate)="row">
													{{ row.item.stockAdjustmentDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedStockAdjustment.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockAdjustments" :fields="fieldsStockAdjustment" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockAdjustment" :sort-desc.sync="sortDescStockAdjustment" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(stockAdjustmentDate)="row">
													{{ row.item.stockAdjustmentDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Stock Adjustment Detail" active>

                                <b-row v-if="hasFailedDataStockAdjustmentDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedStockAdjustmentDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockAdjustmentDetailsFailed" :fields="fieldsStockAdjustmentDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockAdjustmentDetail" :sort-desc.sync="sortDescStockAdjustmentDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtySytem)="row">
													{{ Number(row.item.qtySytem).toLocaleString() }}
												</template>
												<template #cell(qtyAdjustment)="row">
													{{ Number(row.item.qtyAdjustment).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedStockAdjustmentDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockAdjustmentDetails" :fields="fieldsStockAdjustmentDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockAdjustmentDetail" :sort-desc.sync="sortDescStockAdjustmentDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtySytem)="row">
													{{ Number(row.item.qtySytem).toLocaleString() }}
												</template>
												<template #cell(qtyAdjustment)="row">
													{{ Number(row.item.qtyAdjustment).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import StockAdjustment from '@/models/StockAdjustment/StockAdjustment';
import StockAdjustmentList from '@/models/StockAdjustment/StockAdjustmentList';
import StockAdjustmentFilter from '@/filters/StockAdjustment/StockAdjustmentFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsStockAdjustment: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Stock Adjustment Date", key: 'stockAdjustmentDate', sortable: false},
				{"class" : "th-status", "label" : "Stock Adjustment Type", key: 'stockAdjustmentTypeName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsStockAdjustmentDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				//{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				//{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				//{"class" : "th-status", "label" : "Qty Sistem", key: 'qtySytem', sortable: false},
				{"class" : "th-status", "label" : "Qty Adjustment", key: 'qtyAdjustment', sortable: false},
				{"class" : "th-status", "label" : "Qty After", key: 'qtyAfter', sortable: false},
				{"class" : "th-status", "label" : "Reason", key: 'reason', sortable: false},
				//{"class" : "th-status", "label" : "Control Card Status Before ", key: 'controlCardStatusBeforeName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			stockAdjustments : [],
			stockAdjustmentsFailed: [],
			stockAdjustmentId : '',
			sortByStockAdjustment: '',
			sortDescStockAdjustment: '',
			hasFailedDataStockAdjustment: false,
			totalFailedStockAdjustment: 0,
			totalSucceedStockAdjustment: 0,
			stockAdjustmentDetails : [],
			stockAdjustmentDetailsFailed: [],
			stockAdjustmentDetailId : '',
			sortByStockAdjustmentDetail: '',
			sortDescStockAdjustmentDetail: '',
			hasFailedDataStockAdjustmentDetail: false,
			totalFailedStockAdjustmentDetail: 0,
			totalSucceedStockAdjustmentDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('stockadjustment/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('stockadjustment/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getStockAdjustmentForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getStockAdjustmentForUpload : async function() {
			let _this = this;
			this.$http.get('stockadjustment/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.stockAdjustments = [];
_this.stockAdjustmentDetails = [];


					if (response != null) {
						let result = response.data;
						_this.stockAdjustments = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedStockAdjustment = _this.stockAdjustments.length;

						_this.stockAdjustmentsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataStockAdjustment = true;
						_this.totalFailedStockAdjustment = 0;
						if(_this.stockAdjustmentsFailed == undefined || _this.stockAdjustmentsFailed.length === 0) _this.hasFailedDataStockAdjustment = false;
						if(_this.hasFailedDataStockAdjustment) _this.totalFailedStockAdjustment = _this.stockAdjustmentsFailed.length;
						_this.stockAdjustmentDetails = [];
						_this.stockAdjustmentDetailsFailed = [];
						_this.hasFailedDataStockAdjustmentDetail = true;
						_this.totalSucceedStockAdjustmentDetail = 0;
						result.forEach(function(element) {
							_this.stockAdjustmentDetails.push(...element.stockAdjustmentDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedStockAdjustmentDetail = _this.stockAdjustmentDetails.length;

							_this.stockAdjustmentDetailsFailed.push(...element.stockAdjustmentDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.stockAdjustmentDetailsFailed == undefined || _this.stockAdjustmentDetailsFailed.length === 0) _this.hasFailedDataStockAdjustmentDetail = false;
							if(_this.hasFailedDataStockAdjustmentDetail) _this.totalFailedStockAdjustmentDetail = _this.stockAdjustmentDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'stockadjustment/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'StockAdjustment.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterStockAdjustment = new StockAdjustmentFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
